import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
// import CustomTextField from "../../../components/textField";
import { Box, useMediaQuery } from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import AutoCompleteDropdown from "../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../../../components/common/new/InputField/InputField";
import { NEW_ENTRY_FIELDS } from "../../../../contants/formFields";
import IntroductionFormApi from "../../../../services/api/introductionForm";
import { getOptions } from "../../../../utils";
import Styles from "./ChangeToNewFriend.styles";

function ConvertToNewfriendForm({
  handleChange,
  errors,
  values,
  setFieldValue,
}) {
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [profession, setProfession] = useState([]);

  const REQUIRED_DIVISIONS = [52, 53];
  const isMobile = useMediaQuery("(max-width: 768px)");

  const getDivisions = async () => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);
  };

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
  };

  const getCountries = async () => {
    const response = await IntroductionFormApi.getCountries();
    setCountries(response.data);
  };
  const getProfessions = async () => {
    const response = await IntroductionFormApi.getProfessions();
    setProfession(response.data);
  };

  useEffect(() => {
    getDivisions();
    getStates();
    getCountries();
    getProfessions();
  }, []);

  useEffect(() => {
    if (values.divisionId && divisions?.length) {
      const selectedDivisionId = values.divisionId;
      setSubDivisions(
        divisions.find((d) => d.divisionId === Number(selectedDivisionId))
          ?.subDivisions
      );
    }
  }, [values.divisionId, divisions]);

  useEffect(() => {
    if (values.state && states?.length) {
      const fullState = states.find((d) => d.stateId === Number(values.state));
      setCities(fullState?.cities ?? []);
      setFieldValue(NEW_ENTRY_FIELDS.STATE_NAME, fullState?.stateName ?? "");
    }
  }, [values.state, states]); // ✅ values.states → values.state bhi fix hai

  useEffect(() => {
    if (values.city && cities?.length) {
      const fullCity = cities.find((c) => c.cityId === Number(values.city));
      setFieldValue(NEW_ENTRY_FIELDS.CITY_NAME, fullCity?.cityName ?? "");
    }
  }, [values.city, cities]);
  const Style = StyleSheet.create({
    gridContainer: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "1fr",
      gridRowGap: "1.5rem",
      gridColumnGap: "3.75rem",
      "@media (max-width: 768px)": {
        gridRowGap: "1rem",
        gridColumnGap: "1.5rem",
      },
    },
  });
  return (
    <Box className={css(Style.gridContainer)}>
      <div style={{ ...Styles.gridItem, ...Styles.name }}>
        <InputField
          required
          label="New Friend Name"
          name={NEW_ENTRY_FIELDS.NAME}
          value={values[NEW_ENTRY_FIELDS.NAME]}
          error={errors[NEW_ENTRY_FIELDS.NAME]}
          onChange={handleChange}
        />
      </div>
      <div
        style={
          isMobile ? { ...Styles.gridItem, ...Styles.name } : Styles.gridItem
        }
      >
        <InputField
          required
          label="Address"
          name={NEW_ENTRY_FIELDS.ADDRESS_LINE_1}
          onChange={handleChange}
          value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_1]}
        />
      </div>
      <div style={Styles.gridItem}>
        <InputField
          label="Pincode"
          name={NEW_ENTRY_FIELDS.PINCODE}
          onChange={handleChange}
          value={values[NEW_ENTRY_FIELDS.PINCODE]}
          inputProps={{
            maxLength: 6,
          }}
        />
      </div>
      {/* <div style={Styles.gridItem}>
        <InputField
          label="Address Line 2"
          name={NEW_ENTRY_FIELDS.ADDRESS_LINE_2}
          onChange={handleChange}
          value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_2]}
        />
      </div> */}
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.stateName}
          label="State"
          name={NEW_ENTRY_FIELDS.STATE}
          options={getOptions(states, "stateId")}
          error={errors[NEW_ENTRY_FIELDS.STATE]}
          value={Number(values[NEW_ENTRY_FIELDS.STATE])}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_ENTRY_FIELDS.STATE, "");
              setCities([]);
            } else {
              setFieldValue(NEW_ENTRY_FIELDS.STATE, selectedValue.value);
              setCities(selectedValue.cities);
            }
            setFieldValue(NEW_ENTRY_FIELDS.CITY, "");
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.cityName}
          label="City"
          name={NEW_ENTRY_FIELDS.CITY}
          options={getOptions(cities, "cityId")}
          error={errors[NEW_ENTRY_FIELDS.CITY]}
          value={Number(values[NEW_ENTRY_FIELDS.CITY])}
          disabled={!values[NEW_ENTRY_FIELDS.STATE]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_ENTRY_FIELDS.CITY, "");
            } else {
              setFieldValue(NEW_ENTRY_FIELDS.CITY, selectedValue.value);
            }
          }}
        />
      </div>
      {/* <div style={Styles.gridItem} /> */}
      <div style={Styles.gridItem}>
        <InputField
          required
          label="Contact Number"
          name={NEW_ENTRY_FIELDS.CONTACT_NUMBER}
          onChange={handleChange}
          value={values[NEW_ENTRY_FIELDS.CONTACT_NUMBER]}
          inputProps={{
            maxLength: 10,
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <InputField
          label="Email Address"
          name={NEW_ENTRY_FIELDS.EMAIL_ADDRESS}
          onChange={handleChange}
          value={values[NEW_ENTRY_FIELDS.EMAIL_ADDRESS]}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          label="Division"
          name={NEW_ENTRY_FIELDS.DIVISION}
          options={getOptions(divisions, "divisionId")}
          error={errors[NEW_ENTRY_FIELDS.DIVISION]}
          value={values[NEW_ENTRY_FIELDS.DIVISION]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_ENTRY_FIELDS.DIVISION, "");
              setSubDivisions([]);
            } else {
              setFieldValue(NEW_ENTRY_FIELDS.DIVISION, selectedValue.value);
              setSubDivisions(selectedValue.subDivisions);
            }
            setFieldValue(NEW_ENTRY_FIELDS.SUB_DIVISION, "");
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          label="Sub Division"
          name={NEW_ENTRY_FIELDS.SUB_DIVISION}
          options={getOptions(subDivisions, "divisionId")}
          error={errors[NEW_ENTRY_FIELDS.SUB_DIVISION]}
          value={values[NEW_ENTRY_FIELDS.SUB_DIVISION]}
          inputProps={
            REQUIRED_DIVISIONS.includes(values[NEW_ENTRY_FIELDS.DIVISION])
              ? { required: true }
              : { required: false }
          }
          disabled={!values[NEW_ENTRY_FIELDS.DIVISION]}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_ENTRY_FIELDS.SUB_DIVISION, "");
            } else {
              setFieldValue(NEW_ENTRY_FIELDS.SUB_DIVISION, selectedValue.value);
            }
          }}
        />
      </div>
      {values[NEW_ENTRY_FIELDS.DIVISION] === 52 ||
      values[NEW_ENTRY_FIELDS.DIVISION] === 53 ? (
        <>
          <div style={Styles.gridItem}>
            <InputField
              required
              label="Parent's Contact Number"
              name={NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER}
              value={values[NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER]}
              onChange={handleChange}
              error={errors[NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER]}
              inputProps={{
                maxLength: 10,
              }}
            />
          </div>
          <div style={Styles.gridItem}>
            <InputField
              required
              label="Parent's Email Address"
              name={NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS}
              value={values[NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS]}
              error={errors[NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS]}
              onChange={handleChange}
            />
          </div>
        </>
      ) : null}
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          name={NEW_ENTRY_FIELDS.PROFESSION}
          label="Profession"
          variant="standard"
          inputProps={{ required: true }}
          value={values[NEW_ENTRY_FIELDS.PROFESSION]}
          error={errors[NEW_ENTRY_FIELDS.NAME]}
          getOptionLabel={(option) => option.profession}
          options={getOptions(profession, "professionsId")}
          // inputProps={{ required: true }}
          onChange={(selectedValue) => {
            setFieldValue(
              NEW_ENTRY_FIELDS.PROFESSION,
              selectedValue?.value ?? ""
            );
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.countryName}
          name={NEW_ENTRY_FIELDS.COUNTRY}
          options={getOptions(countries, "countryId")}
          inputProps={{ required: true }}
          error={errors[NEW_ENTRY_FIELDS.COUNTRY]}
          value={Number(values[NEW_ENTRY_FIELDS.NATIONALITY_ID])}
          label="Nationality/Country"
          onChange={(selectedValue) => {
            setFieldValue(NEW_ENTRY_FIELDS.COUNTRY, selectedValue?.value ?? "");
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <InputField
          required
          label="Introducer's Name"
          name={NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME}
          onChange={handleChange}
          value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME]}
        />
      </div>
      <div style={Styles.gridItem}>
        <InputField
          label="Introducer's Contact Number"
          required
          name={NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER}
          value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]}
          onChange={handleChange}
          inputProps={{
            maxLength: 10,
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <InputField
          label="Introducer's Email Address"
          name={NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL}
          value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL]}
          onChange={handleChange}
        />
      </div>
    </Box>
  );
}

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  values: PropTypes.objectOf(PropTypes.string).isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

ConvertToNewfriendForm.propTypes = propTypes;

export default ConvertToNewfriendForm;
